var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLeaderHubSmall(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "64px",
    height: "58px",
    viewBox: "0 0 64 58",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "leaderHub___small",
    transform: "translate(32.000000, 29.000000) rotate(180.000000) translate(-32.000000, -29.000000) translate(0.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFB74D",
    transform: "translate(20.000000, 29.166667) rotate(30.000000) translate(-20.000000, -29.166667) ",
    x: 14,
    y: 5.25801624e-13,
    width: 12,
    height: 58.3333333,
    rx: 6
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-26",
    fill: "#00C853",
    transform: "translate(31.000000, 49.166667) rotate(90.000000) translate(-31.000000, -49.166667) ",
    x: 25,
    y: 20,
    width: 12,
    height: 58.3333333,
    rx: 6
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-25",
    fill: "#FF4081",
    transform: "translate(44.000000, 29.166667) rotate(-30.000000) translate(-44.000000, -29.166667) ",
    x: 38,
    y: 4.12114787e-13,
    width: 12,
    height: 58.3333333,
    rx: 6
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeaderHubSmall);
export default __webpack_public_path__ + "static/media/leaderHub___small.bc9ec4841d7a4bc7f3c7e7b561882b35.svg";
export { ForwardRef as ReactComponent };